import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import AppBar from '@mui/material/AppBar';

const StyledAppBar = styled(AppBar)`
  ${ComponentStyles}
`;

StyledAppBar.propTypes = {
  theme: PropTypes.object
};

export default StyledAppBar;
